import moment from "moment";
import {initialCampaignForm} from "./constants";

// Splits pasted text into phone numbers, one per line
export const splitNumbers = (text) => (text || "")
  .split(/\r?\n/)
  .map(value => value.trim())
  .filter(value => value.length > 0);

export const paginate = (items, page, rowsPerPage) => {
  const maxPage = Math.max(0, Math.ceil(items.length / rowsPerPage) - 1);
  const currentPage = Math.min(page, maxPage);
  return {
    currentPage,
    pageItems: items.slice(currentPage * rowsPerPage, currentPage * rowsPerPage + rowsPerPage),
  };
};

// Times come back as HH:mm or HH:mm:ss; <input type="time"> wants HH:mm
const toTimeInput = (value) => (value || "").slice(0, 5);

export const campaignToForm = (campaign) => {
  if (!campaign) return initialCampaignForm;
  return {
    name: campaign.name || "",
    description: campaign.description || "",
    fromNumber: campaign.fromNumber || "",
    extensionId: campaign.extensionId || "",
    startDate: campaign.startDate || "",
    endDate: campaign.endDate || "",
    startTime: toTimeInput(campaign.startTime) || initialCampaignForm.startTime,
    endTime: toTimeInput(campaign.endTime) || initialCampaignForm.endTime,
    maxAttempts: campaign.maxAttempts ?? 1,
  };
};

export const validateCampaignForm = (form) => {
  const errors = {
    endDate: form.startDate && form.endDate && form.endDate < form.startDate
      ? "End date must not be before start date" : null,
    endTime: form.startTime && form.endTime && form.startTime >= form.endTime
      ? "End time must be after start time" : null,
    maxAttempts: !(Number(form.maxAttempts) >= 1) ? "Must be at least 1" : null,
  };

  const isValid = !!form.name.trim()
    && !!form.fromNumber.trim()
    && !!form.extensionId
    && !!(form.startDate && form.endDate && form.startTime && form.endTime)
    && !errors.endDate && !errors.endTime && !errors.maxAttempts;

  return {errors, isValid};
};

// `phoneNumbers` null leaves a campaign's numbers untouched on update
export const buildCampaignBody = (form, phoneNumbers, flowUid) => ({
  flowUid,
  name: form.name.trim(),
  description: form.description?.trim() || null,
  fromNumber: form.fromNumber.trim(),
  extensionId: form.extensionId,
  phoneNumbers: phoneNumbers ? phoneNumbers.map(row => row.value.trim()) : null,
  startDate: form.startDate,
  endDate: form.endDate,
  startTime: form.startTime,
  endTime: form.endTime,
  maxAttempts: Number(form.maxAttempts),
});

// A number can be called while it isn't ringing, hasn't answered and has attempts left
export const canCallNumber = (row, maxAttempts) =>
  row.status !== "ACTIVE" && row.status !== "ANSWERED" && (row.attempts ?? 0) < maxAttempts;

export const formatDateTime = (value) => value ? moment(value).format("DD MMM YYYY HH:mm") : "-";
